import React, { useState } from "react";
import SideBar from "../../../components/SideBar";
import Navigation from "../../../components/Navigation";
import Footer from "../../../components/Footer";
import LogOutModal from "../../../components/modals/LogOutModal";

const ClientDetail = () => {
  const [open, setOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("app");

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleLogOutModal = () => {
    setOpen(!open);
  };

  const pageTitle = "Profile";
  const breadcrumbs = [{ text: "Home", link: "/" }, { text: "Profile" }];

  const TabIcon = ({ paths }) => (
    <svg
      className="text-primary"
      width="16px"
      height="16px"
      viewBox="0 0 42 42"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(-2319.000000, -291.000000)"
          fill="#FFFFFF"
          fillRule="nonzero"
        >
          <g transform="translate(1716.000000, 291.000000)">
            <g transform="translate(603.000000, 0.000000)">
              {paths.map((path, index) => (
                <path
                  key={index}
                  className="fill-primary-dark"
                  d={path.d}
                  opacity={path.opacity}
                ></path>
              ))}
            </g>
          </g>
        </g>
      </g>
    </svg>
  );

  const TabButton = ({ id, label, paths }) => (
    <li className="z-30 flex-auto text-center">
      <button
        className={`z-30 flex items-center justify-center w-full px-0 py-1 mb-0 transition-all border-0 rounded-lg ease-soft-in-out bg-inherit text-primary ${
          activeTab === id ? "bg-white shadow-soft-xxs" : ""
        }`}
        role="tab"
        aria-selected={activeTab === id}
        onClick={() => setActiveTab(id)}
      >
        <TabIcon paths={paths} />
        <span className="ml-2">{label}</span>
      </button>
    </li>
  );

  const handleInputChange = (e) => {
    // Handle input changes here
    // console.log(e.target.name, e.target.value);
  };

  return (
    <div className="m-0 font-sans antialiased font-normal text-base leading-default bg-gray-50 text-primary-light">
      <SideBar
        options={{ open, toggleLogOutModal }}
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
      />

      <main className="ease-soft-in-out xl:ml-68.5 relative h-full max-h-screen rounded-xl transition-all duration-200 w-auto">
        <Navigation
          pageTitle={pageTitle}
          breadcrumbs={breadcrumbs}
          isSidebarOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
        />

        <div className="w-full px-6 mx-auto">
          <div
            className="relative flex items-center p-0 mt-6 overflow-hidden bg-center bg-cover min-h-75 rounded-2xl"
            style={{
              backgroundImage: "url(/assets/img/curved-images/curved0.jpg)",
              backgroundPositionY: "50%",
            }}
          >
            <span className="absolute inset-y-0 w-full h-full bg-center bg-cover bg-gradient-to-tl from-primary to-primary-light opacity-60"></span>
          </div>
          <div className="relative flex flex-col flex-auto min-w-0 p-4 mx-6 -mt-16 overflow-hidden break-words border-0 shadow-blur rounded-2xl bg-white/80 bg-clip-border backdrop-blur-2xl backdrop-saturate-200">
            <div className="flex flex-wrap -mx-3">
              <div className="flex-none w-auto max-w-full px-3">
                <div className="text-base ease-soft-in-out h-18.5 w-18.5 relative inline-flex items-center justify-center rounded-xl text-white transition-all duration-200">
                  <img
                    src="../assets/img/bruce-mars.jpg"
                    alt="profile_image"
                    className="w-full shadow-soft-sm rounded-xl"
                  />
                </div>
              </div>
              <div className="flex-none w-auto max-w-full px-3 my-auto">
                <div className="h-full">
                  <h5 className="mb-1">Alec Thompson</h5>
                  <p className="mb-0 font-semibold leading-normal text-sm">
                    CEO / Co-Founder
                  </p>
                </div>
              </div>
              <div className="w-full max-w-full px-3 mx-auto mt-4 sm:my-auto sm:mr-0 md:w-1/2 md:flex-none lg:w-4/12">
                <div className="relative right-0">
                  <ul
                    className="relative flex flex-wrap p-1 list-none bg-transparent rounded-xl"
                    data-nav-pills
                    role="tablist"
                  >
                    <TabButton
                      id="app"
                      label="App"
                      paths={[
                        {
                          d: "M22.7597136,19.3090182 L38.8987031,11.2395234 C39.3926816,10.9925342 39.592906,10.3918611 39.3459167,9.89788265 C39.249157,9.70436312 39.0922432,9.5474453 38.8987261,9.45068056 L20.2741875,0.1378125 L20.2741875,0.1378125 C19.905375,-0.04725 19.469625,-0.04725 19.0995,0.1378125 L3.1011696,8.13815822 C2.60720568,8.38517662 2.40701679,8.98586148 2.6540352,9.4798254 C2.75080129,9.67332903 2.90771305,9.83023153 3.10122239,9.9269862 L21.8652864,19.3090182 C22.1468139,19.4497819 22.4781861,19.4497819 22.7597136,19.3090182 Z",
                        },
                        {
                          d: "M23.625,22.429159 L23.625,39.8805372 C23.625,40.4328219 24.0727153,40.8805372 24.625,40.8805372 C24.7802551,40.8805372 24.9333778,40.8443874 25.0722402,40.7749511 L41.2741875,32.673375 L41.2741875,32.673375 C41.719125,32.4515625 42,31.9974375 42,31.5 L42,14.241659 C42,13.6893742 41.5522847,13.241659 41,13.241659 C40.8447549,13.241659 40.6916418,13.2778041 40.5527864,13.3472318 L24.1777864,21.5347318 C23.8390024,21.7041238 23.625,22.0503869 23.625,22.429159 Z",
                          opacity: "0.7",
                        },
                        {
                          d: "M20.4472136,21.5347318 L1.4472136,12.0347318 C0.953235098,11.7877425 0.352562058,11.9879669 0.105572809,12.4819454 C0.0361450918,12.6208008 6.47121774e-16,12.7739139 0,12.929159 L0,30.1875 L0,30.1875 C0,30.6849375 0.280875,31.1390625 0.7258125,31.3621875 L19.5528096,40.7750766 C20.0467945,41.0220531 20.6474623,40.8218132 20.8944388,40.3278283 C20.963859,40.1889789 21,40.0358742 21,39.8806379 L21,22.429159 C21,22.0503869 20.7859976,21.7041238 20.4472136,21.5347318 Z",
                          opacity: "0.7",
                        },
                      ]}
                    />

                    <TabButton
                      id="settings"
                      label="Settings"
                      paths={[
                        {
                          d: "M18.0883333 15.7316667 11.1783333 8.82166667 13.3333333 6.66666667 6.66666667 0 0 6.66666667 6.66666667 13.3333333 8.82166667 11.1783333 15.315 17.6716667",
                          opacity: "0.596981957",
                        },
                        {
                          d: "M31.5666667,23.2333333 C31.0516667,23.2933333 30.53,23.3333333 30,23.3333333 C29.4916667,23.3333333 28.9866667,23.3033333 28.48,23.245 L22.4116667,30.7433333 L29.9416667,38.2733333 C32.2433333,40.575 35.9733333,40.575 38.275,38.2733333 L38.275,38.2733333 C40.5766667,35.9716667 40.5766667,32.2416667 38.275,29.94 L31.5666667,23.2333333 Z",
                          opacity: "0.596981957",
                        },
                        {
                          d: "M33.785,11.285 L28.715,6.215 L34.0616667,0.868333333 C32.82,0.315 31.4483333,0 30,0 C24.4766667,0 20,4.47666667 20,10 C20,10.99 20.1483333,11.9433333 20.4166667,12.8466667 L2.435,27.3966667 C0.95,28.7083333 0.0633333333,30.595 0.00333333333,32.5733333 C-0.0583333333,34.5533333 0.71,36.4916667 2.11,37.89 C3.47,39.2516667 5.27833333,40 7.20166667,40 C9.26666667,40 11.2366667,39.1133333 12.6033333,37.565 L27.1533333,19.5833333 C28.0566667,19.8516667 29.01,20 30,20 C35.5233333,20 40,15.5233333 40,10 C40,8.55166667 39.685,7.18 39.1316667,5.93666667 L33.785,11.285 Z",
                        },
                      ]}
                    />
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full px-6 py-6 mx-auto">
          {activeTab === "app" && (
            <div className="flex flex-wrap -mx-3 lg:mb-10">
              <div className="w-full max-w-full px-3 xl:w-5/12">
                <div className="relative flex flex-col h-full min-w-0 break-words bg-white border-0 shadow-soft-xl rounded-2xl bg-clip-border">
                  <div className="p-4 pb-0 mb-0 bg-white border-b-0 rounded-t-2xl">
                    <h6 className="mb-0">Platform Settings</h6>
                  </div>
                  <div className="flex-auto p-4">
                    <h6 className="font-bold leading-tight uppercase text-xs text-primary-light">
                      Account
                    </h6>
                    <ul className="flex flex-col pl-0 mb-0 rounded-lg">
                      <li className="relative block px-0 py-2 bg-white border-0 rounded-t-lg text-inherit">
                        <div className="min-h-6 mb-0.5 block pl-0">
                          <input
                            id="follow"
                            className="mt-0.54 rounded-10 duration-250 ease-soft-in-out after:rounded-circle after:shadow-soft-2xl after:duration-250 checked:after:translate-x-5.25 h-5 relative float-left ml-auto w-10 cursor-pointer appearance-none border border-solid border-gray-200 bg-slate-800/10 bg-none bg-contain bg-left bg-no-repeat align-top transition-all after:absolute after:top-px after:h-4 after:w-4 after:translate-x-px after:bg-white after:content-[''] checked:border-slate-800/95 checked:bg-slate-800/95 checked:bg-none checked:bg-right"
                            type="checkbox"
                            onChange={handleInputChange}
                          />
                          <label
                            htmlFor="follow"
                            className="w-4/5 mb-0 ml-4 overflow-hidden font-normal cursor-pointer select-none text-sm text-ellipsis whitespace-nowrap text-primary-light"
                          >
                            Email me when someone follows me
                          </label>
                        </div>
                      </li>
                      <li className="relative block px-0 py-2 bg-white border-0 text-inherit">
                        <div className="min-h-6 mb-0.5 block pl-0">
                          <input
                            id="answer"
                            className="mt-0.54 rounded-10 duration-250 ease-soft-in-out after:rounded-circle after:shadow-soft-2xl after:duration-250 checked:after:translate-x-5.25 h-5 relative float-left ml-auto w-10 cursor-pointer appearance-none border border-solid border-gray-200 bg-slate-800/10 bg-none bg-contain bg-left bg-no-repeat align-top transition-all after:absolute after:top-px after:h-4 after:w-4 after:translate-x-px after:bg-white after:content-[''] checked:border-slate-800/95 checked:bg-slate-800/95 checked:bg-none checked:bg-right"
                            type="checkbox"
                          />
                          <label
                            htmlFor="answer"
                            className="w-4/5 mb-0 ml-4 overflow-hidden font-normal cursor-pointer select-none text-sm text-ellipsis whitespace-nowrap text-primary-light"
                          >
                            Email me when someone answers on my post
                          </label>
                        </div>
                      </li>
                      <li className="relative block px-0 py-2 bg-white border-0 rounded-b-lg text-inherit">
                        <div className="min-h-6 mb-0.5 block pl-0">
                          <input
                            id="mention"
                            className="mt-0.54 rounded-10 duration-250 ease-soft-in-out after:rounded-circle after:shadow-soft-2xl after:duration-250 checked:after:translate-x-5.25 h-5 relative float-left ml-auto w-10 cursor-pointer appearance-none border border-solid border-gray-200 bg-slate-800/10 bg-none bg-contain bg-left bg-no-repeat align-top transition-all after:absolute after:top-px after:h-4 after:w-4 after:translate-x-px after:bg-white after:content-[''] checked:border-slate-800/95 checked:bg-slate-800/95 checked:bg-none checked:bg-right"
                            type="checkbox"
                            checked
                          />
                          <label
                            htmlFor="mention"
                            className="w-4/5 mb-0 ml-4 overflow-hidden font-normal cursor-pointer select-none text-sm text-ellipsis whitespace-nowrap text-primary-light"
                          >
                            Email me when someone mentions me
                          </label>
                        </div>
                      </li>
                    </ul>
                    <h6 className="mt-6 font-bold leading-tight uppercase text-xs text-slate-500">
                      Application
                    </h6>
                    <ul className="flex flex-col pl-0 mb-0 rounded-lg">
                      <li className="relative block px-0 py-2 bg-white border-0 rounded-t-lg text-inherit">
                        <div className="min-h-6 mb-0.5 block pl-0">
                          <input
                            id="launches projects"
                            className="mt-0.54 rounded-10 duration-250 ease-soft-in-out after:rounded-circle after:shadow-soft-2xl after:duration-250 checked:after:translate-x-5.25 h-5 relative float-left ml-auto w-10 cursor-pointer appearance-none border border-solid border-gray-200 bg-slate-800/10 bg-none bg-contain bg-left bg-no-repeat align-top transition-all after:absolute after:top-px after:h-4 after:w-4 after:translate-x-px after:bg-white after:content-[''] checked:border-slate-800/95 checked:bg-slate-800/95 checked:bg-none checked:bg-right"
                            type="checkbox"
                          />
                          <label
                            htmlFor="launches projects"
                            className="w-4/5 mb-0 ml-4 overflow-hidden font-normal cursor-pointer select-none text-sm text-ellipsis whitespace-nowrap text-primary-light"
                          >
                            New launches and projects
                          </label>
                        </div>
                      </li>
                      <li className="relative block px-0 py-2 bg-white border-0 text-inherit">
                        <div className="min-h-6 mb-0.5 block pl-0">
                          <input
                            id="product updates"
                            className="mt-0.54 rounded-10 duration-250 ease-soft-in-out after:rounded-circle after:shadow-soft-2xl after:duration-250 checked:after:translate-x-5.25 h-5 relative float-left ml-auto w-10 cursor-pointer appearance-none border border-solid border-gray-200 bg-slate-800/10 bg-none bg-contain bg-left bg-no-repeat align-top transition-all after:absolute after:top-px after:h-4 after:w-4 after:translate-x-px after:bg-white after:content-[''] checked:border-slate-800/95 checked:bg-slate-800/95 checked:bg-none checked:bg-right"
                            type="checkbox"
                            checked
                          />
                          <label
                            htmlFor="product updates"
                            className="w-4/5 mb-0 ml-4 overflow-hidden font-normal cursor-pointer select-none text-sm text-ellipsis whitespace-nowrap text-primary-light"
                          >
                            Monthly product updates
                          </label>
                        </div>
                      </li>
                      <li className="relative block px-0 py-2 pb-0 bg-white border-0 rounded-b-lg text-inherit">
                        <div className="min-h-6 mb-0.5 block pl-0">
                          <input
                            id="subscribe"
                            className="mt-0.54 rounded-10 duration-250 ease-soft-in-out after:rounded-circle after:shadow-soft-2xl after:duration-250 checked:after:translate-x-5.25 h-5 relative float-left ml-auto w-10 cursor-pointer appearance-none border border-solid border-gray-200 bg-slate-800/10 bg-none bg-contain bg-left bg-no-repeat align-top transition-all after:absolute after:top-px after:h-4 after:w-4 after:translate-x-px after:bg-white after:content-[''] checked:border-slate-800/95 checked:bg-slate-800/95 checked:bg-none checked:bg-right"
                            type="checkbox"
                          />
                          <label
                            htmlFor="subscribe"
                            className="w-4/5 mb-0 ml-4 overflow-hidden font-normal cursor-pointer select-none text-sm text-ellipsis whitespace-nowrap text-primary-light"
                          >
                            Subscribe to newsletter
                          </label>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="w-full max-w-full px-3 lg-max:mt-6 xl:w-7/12">
                <div className="relative flex flex-col h-full min-w-0 break-words bg-white border-0 shadow-soft-xl rounded-2xl bg-clip-border">
                  <div className="p-4 pb-0 mb-0 bg-white border-b-0 rounded-t-2xl">
                    <div className="flex flex-wrap -mx-3">
                      <div className="flex items-center w-full max-w-full px-3 shrink-0 md:w-8/12 md:flex-none">
                        <h6 className="mb-0">Profile Information</h6>
                      </div>
                    </div>
                  </div>
                  <div className="flex-auto p-4">
                    <p className="leading-normal text-sm">
                      Hi, I’m Alec Thompson, Decisions: If you can’t decide, the
                      answer is no. If two equally difficult paths, choose the
                      one more painful in the short term (pain avoidance is
                      creating an illusion of equality).
                    </p>
                    <hr className="h-px my-6 bg-transparent bg-gradient-to-r from-transparent via-white to-transparent" />
                    <ul className="flex flex-col pl-0 mb-0 rounded-lg">
                      <li className="relative block px-4 py-2 pt-0 pl-0 leading-normal bg-white border-0 rounded-t-lg text-sm text-inherit">
                        <strong className="text-primary">Full Name:</strong>{" "}
                        &nbsp; Alec M. Thompson
                      </li>
                      <li className="relative block px-4 py-2 pl-0 leading-normal bg-white border-0 border-t-0 text-sm text-inherit">
                        <strong className="text-primary">Mobile:</strong> &nbsp;
                        (44) 123 1234 123
                      </li>
                      <li className="relative block px-4 py-2 pl-0 leading-normal bg-white border-0 border-t-0 text-sm text-inherit">
                        <strong className="text-primary">Email:</strong> &nbsp;
                        alecthompson@mail.com
                      </li>
                      <li className="relative block px-4 py-2 pl-0 leading-normal bg-white border-0 border-t-0 text-sm text-inherit">
                        <strong className="text-primary">Location:</strong>{" "}
                        &nbsp; Airfield Sinkor{" "}
                      </li>
                      <li className="relative block px-4 py-2 pb-0 pl-0 bg-white border-0 border-t-0 rounded-b-lg text-inherit">
                        <strong className="leading-normal text-sm text-slate-700">
                          Social:
                        </strong>{" "}
                        &nbsp;
                        <a
                          className="inline-block py-0 pl-1 pr-2 mb-0 font-bold text-center text-blue-800 align-middle transition-all bg-transparent border-0 rounded-lg shadow-none cursor-pointer leading-pro text-xs ease-soft-in bg-none"
                          href="/"
                        >
                          <i className="fab fa-facebook fa-lg"></i>
                        </a>
                        <a
                          className="inline-block py-0 pl-1 pr-2 mb-0 font-bold text-center align-middle transition-all bg-transparent border-0 rounded-lg shadow-none cursor-pointer leading-pro text-xs ease-soft-in bg-none text-sky-600"
                          href="/"
                        >
                          <i className="fab fa-twitter fa-lg"></i>
                        </a>
                        <a
                          className="inline-block py-0 pl-1 pr-2 mb-0 font-bold text-center align-middle transition-all bg-transparent border-0 rounded-lg shadow-none cursor-pointer leading-pro text-xs ease-soft-in bg-none text-sky-900"
                          href="/"
                        >
                          <i className="fab fa-instagram fa-lg"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeTab === "settings" && (
            <div className="container mx-auto px-4">
              <h1 className="text-2xl font-bold mb-6">Profile Information</h1>
              <div className="flex flex-wrap -mx-3">
                <div className="w-full md:w-6/12 px-3 mb-6">
                  <div className="bg-white rounded-lg shadow-md p-6">
                    <h2 className="text-xl font-semibold mb-4">
                      Profile Information
                    </h2>
                    <form>
                      <div className="mb-4">
                        <label
                          className="block text-gray-700 text-sm font-bold mb-2"
                          htmlFor="fullName"
                        >
                          Full Name
                        </label>
                        <input
                          className=" appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                          id="fullName"
                          type="text"
                          placeholder="Alex M. Thompson"
                        />
                      </div>
                      <div className="mb-4">
                        <label
                          className="block text-gray-700 text-sm font-bold mb-2"
                          htmlFor="email"
                        >
                          Email
                        </label>
                        <input
                          className=" appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                          id="email"
                          type="email"
                          placeholder="alexthompson@gmail.com"
                        />
                      </div>
                      <div className="mb-4">
                        <label
                          className="block text-gray-700 text-sm font-bold mb-2"
                          htmlFor="phone"
                        >
                          Phone
                        </label>
                        <input
                          className=" appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                          id="phone"
                          type="tel"
                          placeholder="(441) 123 1234 723"
                        />
                      </div>
                      <div className="mb-4">
                        <label
                          className="block text-gray-700 text-sm font-bold mb-2"
                          htmlFor="location"
                        >
                          Location
                        </label>
                        <input
                          className="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                          id="location"
                          type="text"
                          placeholder="Airfield Sinkor"
                        />
                      </div>
                      <button
                        className="bg-primary-light hover:bg-primary text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        type="button"
                      >
                        Update Profile
                      </button>
                    </form>
                  </div>
                </div>
                <div className="w-full md:w-6/12 px-3 mb-6">
                  <div className="bg-white rounded-lg shadow-md p-6">
                    <h2 className="text-xl font-semibold mb-4">
                      Change Password
                    </h2>
                    <form>
                      <div className="mb-4">
                        <label
                          className="block text-gray-700 text-sm font-bold mb-2"
                          htmlFor="currentPassword"
                        >
                          Current Password
                        </label>
                        <input
                          className=" appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                          id="currentPassword"
                          type="password"
                          placeholder="••••••••"
                        />
                      </div>
                      <div className="mb-4">
                        <label
                          className="block text-gray-700 text-sm font-bold mb-2"
                          htmlFor="newPassword"
                        >
                          New Password
                        </label>
                        <input
                          className=" appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                          id="newPassword"
                          type="password"
                          placeholder="••••••••"
                        />
                      </div>
                      <div className="mb-6">
                        <label
                          className="block text-gray-700 text-sm font-bold mb-2"
                          htmlFor="confirmNewPassword"
                        >
                          Confirm New Password
                        </label>
                        <input
                          className=" appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                          id="confirmNewPassword"
                          type="password"
                          placeholder="••••••••"
                        />
                      </div>
                      <button
                        className="bg-primary-light hover:bg-primary text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        type="button"
                      >
                        Change Password
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          )}
          <Footer />
        </div>
      </main>
      <LogOutModal options={{ open, setOpen, toggleLogOutModal }} />
    </div>
  );
};

export default ClientDetail;
